<template>
       <!-- Start Main Content -->
       <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
            <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
                <div>
                    <h6 class="card-title">Customers</h6>
                </div>
                <a href="#" class="btn b-solid btn-primary-solid" data-modal-target="editModal" @click="addModal()">Add Customer</a>
            </div>
            <!-- Start All Language List Table -->
            
           <div class="card">

                <div class="row" style="display: flex; gap: 1rem;">

                       <div class="mt-6">
                            <button @click="show_status(1)" class="btn b-solid btn-danger-solid cursor-pointer shadow-sm">Balance>0</button>
                        </div> 

                        
                       <div class="mt-6">
                            <button @click="show_status(2)" class="btn b-solid btn-success-solid cursor-pointer shadow-sm">ALL</button>
                        </div> 

                    </div>
                    </div>



            <div class="p-3 sm:p-4">
                <div class="overflow-x-auto scrollbar-table">
                    <table class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none datatable" id="datatable" >
                        <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                            <tr>
                                <th class="px-3.5 py-4">Sr No</th>
                                <th class="px-3.5 py-4">Name</th>
                                <th class="px-3.5 py-4">Contact</th>
                                <th class="px-3.5 py-4">GST</th>
                                <th class="px-3.5 py-4">Address</th>
                                <th class="px-3.5 py-4 text-info"><strong>Balance</strong></th>
                                <th class="px-3.5 py-4">Action</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-200 dark:divide-dark-border" >
                            <tr class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white" v-for="(item ,index)  in CustomerList" :key="item.id" > 
                                <td class="px-3.5 py-4">{{index+1}}</td>
                              <td class="px-3.5 py-4">
                                <router-link :to="`/customerhistory?q=${item.id}`" class="text-blue-500 hover:underline">
                                    {{ item.name }}
                                </router-link>
                                </td>
                                <td class="px-3.5 py-4">{{item.cell}}</td>
                                <td class="px-3.5 py-4">{{item.dob}}</td>
                                <td class="px-3.5 py-4">{{item.address}}</td>
                                <td :class="item.balance>0?'px-3.5 py-4 text-danger':'px-3.5 py-4 text-success'"><strong>{{item.balance}}</strong></td>
                                <td class="px-3.5 py-4">
                                    <div class="flex items-center gap-1">
                                        <button class="btn-icon btn-primary-icon-light size-7"  @click="editcustomer(item.id)"  >
                                            <i class="ri-edit-2-line text-inherit text-[13px]"></i>
                                        </button>
                                        <button class="btn-icon btn-primary-icon-light size-7"  @click="accountModal(item)"  >
                                            <i class="ri-cash-line text-inherit text-[13px]"></i>
                                        </button>
                                        <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                            <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                        </button>
                                          <button class="btn-icon btn-danger-icon-light size-7" @click="viewstatment(item.id)" >
                                           <i class="ri-eye-line text-primary text-[13px]"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- End All Language List Table -->
        </div>
    </div>
    <!-- End Main Content -->

    <!-- Start Edit Modal -->
    <div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
              
                <div class="p-4 md:p-5" >
                      <form>
                    <div class="mt-5" v-on:keyup.enter="nextFocus">

                     <input type="hidden" v-model="Customer.id">

                        <div class="mt-5">
                            <label for="tagname" class="form-label">Customer Name *</label>
                            <input type="text" v-model="Customer.name" class="form-input" id="first_input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="mt-5">
                            <label for="tagname" class="form-label">Customer Contact *</label>
                            <input type="text" v-model="Customer.cell" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="mt-5">
                            <label for="tagname" class="form-label">Customer DOB *</label>
                            <input type="date" v-model="Customer.dob" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="mt-5">
                            <label for="tagname" class="form-label">Customer Address *</label>
                            <input type="text" v-model="Customer.address" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div> 
                    </div>
                    </form>

                        <div class="flex justify-end mt-5">
                          
                            <button @click="save"  v-if="Customer.id >0" id="saveBtn" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Update</button>

                              <button @click="save" id="saveBtn" v-else class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                        </div> 
                </div>
            </div>
        </div>
    </div>
    <!-- End Edit Modal -->

    <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_Customer()" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
    
     <div id="accountModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
              
                <div class="p-4 md:p-5" >
                    <h6>Voucher For: {{sel_customer_name}}</h6>
                      <form>
                    <div class="mt-5" v-on:keyup.enter="nextFocus">
                        <div class="mt-5">
                            <label for="first_input" class="form-label">Date*</label>
                            <input type="date" v-model="account.entrydate" class="form-input" id="first_input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="mt-5">
                            <label for="tagname" class="form-label">Paid Amount *</label>
                            <input type="number" v-model="account.paid" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="mt-5">
                            <label for="tagname" class="form-label">Note *</label>
                            <input type="text" v-model="account.note" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        
                    </div>
                    </form>

                        <div class="flex justify-end mt-5">
                            <button @click="saveAccount" id="saveAccBtn" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                        </div> 
                </div>
            </div>
        </div>
    </div>
   
   
   
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
  name: 'Customer',
  components: {
    
  } ,
  mounted(){
    this.getBasics();
  },
  data() {
    return {
        isAccount:0,
        isAdd:0,
        isEdit:0,
        isDelete: 0,
        deleteId:0,
        CustomerList:[],
        updatecustlist:[],
        datatable:null,
        sel_customer_name:'',
        Customer:{id:'',name:'',cell:'',address:'',dob:''},
        employees: {empname:'',emprole:'0',isMainAdmin:0},
        account:{entrydate:this.todayDate(),paid:0,cust_id:0,note:''},
    }
    }, 
  methods:{
    todayDate()
    {
        const dateObj = new Date();
        var month=dateObj.getMonth()+1;
        var day=dateObj.getDate();
        const currentDate = dateObj.getFullYear()+"-"+((month<10)?'0'+month:month)+"-"+((day<10)?'0'+day:day);
        return currentDate;
    },
    closeModal(){
        
            $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
            $("#accountModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
        this.isAccount=0;
    },
    addModal(){
        this.Customer={name:'',cell:'',address:'',gst:''};

        if(!this.isAdd)
            $("#editModal").removeClass('hidden');
        else
            $("#editModal").addClass('hidden');

            $("#first_input").focus();
        this.isAdd=!this.isAdd;
    },
    nextFocus(e) {
            const inputs = Array.from(e.target.form.querySelectorAll('input'));
            const index = inputs.indexOf(e.target);

            if (index < inputs.length) {
                try {
                    inputs[index + 1].focus();
                    inputs[index + 1].select();
                } catch (error) {
                    $("#saveBtn").focus();
                }
            }
        },
        
    accountModal(item){
        if(!this.isAccount)
            $("#accountModal").removeClass('hidden');
        else
            $("#accountModal").addClass('hidden');
            
        this.account.cust_id=item.id;
        this.sel_customer_name=item.name;
        this.isAccount=!this.isAccount;
    },
    
    
    
    editModal(item){
        if(item){
            let copy = JSON.parse(JSON.stringify(item));
            this.cat=copy;
        }
        if(!this.isEdit)
            $("#editModal").removeClass('hidden');
        else
            $("#editModal").addClass('hidden');
        this.isEdit=!this.isEdit;
    },
    
    deleteModal(id){
        this.deleteId=id;
        if(!this.isDelete)
            $("#deleteModal").removeClass('hidden');
        else
            $("#deleteModal").addClass('hidden');
        this.isDelete=!this.isDelete;
    },
    async getBasics() {
          var self=this;

            axios.post('getCustomers').then(function (response) {

                 self.destroyTable();

                    self.CustomerList=response.data.list;
                    self.employees=response.data.userDetails;
                   }).then(()=>{

                    self.refreshTable();

                        });
     },
     save() {
                var self = this; 
                if(self.Customer.name==''){
                    self.$swal("Customer Name is Required");
                }else{
                    axios.post('addCustomer', this.Customer)
                        .then(response => {
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                            self.CustomerList=response.data.list;
                            self.employees=response.data.userDetails;
                            self.Customer={name:'',cell:'',address:'',gst:''};

                            //self.$swal(msg);
                            if (isSuccess == 1) {
                                self.closeModal();
                            }
                        })
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });
                }
            },
            delete_Customer() {
                var self = this; 
                axios.post('deleteCustomer', {deleteId:this.deleteId})
                    .then(response => {s
                      
                        self.CustomerList=response.data.list;
                        self.employees=response.data.userDetails; 
                         self.closeModal(); 
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },
            
            
     saveAccount() {
                var self = this; 
                if(self.account.paid==0){
                    self.$swal("Please Enter Paid Amount");
                }else  if(self.account.cust_id==0){
                    self.$swal("Customer Not Found");
                }else{
                    axios.post('addAccountVoucher', this.account)
                        .then(response => {
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                            self.CustomerList=response.data.list;
                            self.employees=response.data.userDetails;
                            self.Customer={name:'',cell:'',address:'',gst:''};

                            self.$swal(msg);
                            if (isSuccess == 1) {
                                self.closeModal();
                            }
                        })
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });
                }
            },

   editcustomer(id) {
          var self=this;
            axios.post('getcustomerrow',{id:id}).then(function (response) {

                    self.employees=response.data.userDetails;
                    self.Customer=response.data.list;
                           
                    $("#editModal").removeClass('hidden');

                   });
     },

     viewstatment(id){

        this.$router.push(`/accountReport?q=${id}`);

     },



     destroyTable(){
        if ($.fn.dataTable.isDataTable('.datatable')) {
                            $('.datatable').DataTable().destroy();
                        }
    },
        refreshTable(){
            $(".datatable").DataTable({
                            dom: 'Bfrtip',
                            buttons: ['excel', 'pdf'],
                            "paging": true,
                            "ordering": true,
                            "autoWidth": false,
                        });
    },



   show_status(id){

     if(id==1){



        var self=this;

                    axios.post('getCustomers').then(function (response) {

                        self.destroyTable();

                            self.CustomerList=response.data.list.filter(item => item.balance > 0);
                            self.employees=response.data.userDetails;
                        }).then(()=>{

                            self.refreshTable();

                                });


           }else if (2){


  var self=this;

                    axios.post('getCustomers').then(function (response) {

                        self.destroyTable();

                            self.CustomerList=response.data.list;
                            self.employees=response.data.userDetails;
                        }).then(()=>{

                            self.refreshTable();

                                });






           }

   }






  }
}
</script>
